import { Link, useNavigate } from "react-router-dom";
import ellowLogo from "../../assets/images/ellow-logo.svg"; 
import ellowLogoIcon from "../../assets/images/ellow-logo-icon.svg"; 
import { Icon } from '@iconify/react'; 
import Styles from "./styles.module.scss";
import classnames from "classnames"; 
import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import ConfirmationModal from "../../modal/confirmation/confirmationModal";

Auth.configure({
  userPoolId: "ap-south-1_0GE8bPCY8",
  userPoolWebClientId: "qf4m3jr6abvr2i5opelhjsejg", // app client id
  //identityPoolId: "42efbd0d-8bcb-46a2-b028-0a8affe3bb63",
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "https://ellow-prod-provider.auth.ap-south-1.amazoncognito.com",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://myleads.ellow.io/dashboard",
    redirectSignOut: "https://myleads.ellow.io/login",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
});

interface Props {
  menu?: { icon: string, title: string, url: string, active: boolean }[],
  openresource?: string
}



const SideMenu: React.FC<Props> = ({
  menu = [],
  openresource
}) => {

// let customerMetdata =JSON.parse(localStorage.getItem("customerMetdata") || '') || {}
let customerMetdata: any = {};
const storedData = localStorage.getItem("customerMetadata");
if (storedData) {
  try {
   customerMetdata = JSON.parse(storedData);
  } catch (error) {
    customerMetdata = JSON.parse(storedData);
    console.error("Error parsing customerMetadata:", error);
  }
}
  const [logoutModal, setLogoutModal] = useState<boolean>(false)
  let navigate = useNavigate();

useEffect(() => {

  if (openresource) {
    setShow((prev => !prev))
  }
}, [openresource])

  
async function onLogout() {
 
    try {
      await Auth.signOut();
      localStorage.clear();
      navigate('/login')
    } catch (error) {
        
    }
  
}
 
const handleClick = () => {
  document.body.classList.toggle('expandSideMenu');
};

  
const [show, setShow] = useState<boolean>(false);
 
  return (
    <aside className={classnames(Styles.sideMenu, "sideMenu")}>
      {logoutModal && <ConfirmationModal logout={true} onClose={() => setLogoutModal(false)} submit={onLogout} />}
      <div className={Styles.sideMenuWrap}>
        <div className={classnames(Styles.header, "header")}>
          <img src={ellowLogo} className={classnames(Styles.logo, "logo")} alt="ellow.io"/>
          <img src={ellowLogoIcon} className={classnames(Styles.icon, "icon")} alt="ellow.io"/>
          <button onClick={handleClick}><Icon icon="ep:arrow-right-bold" /></button>
        </div>
        <div className={classnames(Styles.userInfo, "userInfo")}>
          <figure>
            {customerMetdata && customerMetdata.firstName && customerMetdata.firstName[0]}
          </figure>
          <figcaption>{ customerMetdata && customerMetdata.firstName }</figcaption>
          <div className={Styles.role}>{customerMetdata && customerMetdata.companyName}</div>
        </div>
        <nav>
        {menu.map((item, key) =>
            <div key={key} className={`subMenu ${show ? "active" : ""}`}>
            <Link to={item.url} onClick={item.title === 'Resources' ? () => { setShow((prev) => !prev);  }
             : undefined} className={item.active ? Styles.active : ""}><Icon icon={item.icon} /><span>{item.title} { item.title === 'Resources' && <Icon icon="ep:arrow-down-bold" />}</span></Link>
            {item.title === 'Resources' && item.active && <div className={classnames(Styles.subLinks, "subLinks")}>
                <Link to='/resources' className={openresource === 'allresources' ? "active" : ""}><span>All</span></Link>
                <Link to='/incontract'className= {openresource === 'incontract' ? "active" : ""}><span>In Contract</span></Link>
               
            </div>}
          </div>
        )
        }
        </nav>
      </div>
      <nav>
        <Link to={''} onClick={() => setLogoutModal(true)}>
          <Icon icon="ic:twotone-logout" />
          <span>Logout</span>
        </Link>
      </nav>
    </aside>
  );
}

export default SideMenu;
